export default function ChatSkeleton() {
  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4">
      {/* Date separator skeleton */}
      <div className="flex justify-center mb-4">
        <div className="bg-gray-200 animate-pulse h-6 w-20 rounded-full"></div>
      </div>
      
      {/* Message skeletons */}
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className={`flex ${i % 2 === 0 ? 'justify-end' : 'justify-start'}`}>
          <div className={`max-w-xs lg:max-w-md px-4 py-3 rounded-lg ${
            i % 2 === 0 ? 'bg-gray-200' : 'bg-gray-100'
          } animate-pulse`}>
            {/* Message content skeleton */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-300 rounded w-3/4"></div>
              {i === 2 && <div className="h-4 bg-gray-300 rounded w-1/2"></div>}
              {i === 4 && (
                <>
                  <div className="h-4 bg-gray-300 rounded w-full"></div>
                  <div className="h-4 bg-gray-300 rounded w-2/3"></div>
                </>
              )}
            </div>
            {/* Timestamp skeleton */}
            <div className="h-3 bg-gray-300 rounded w-12 mt-2"></div>
          </div>
        </div>
      ))}
      
      {/* Another date separator */}
      <div className="flex justify-center mb-4">
        <div className="bg-gray-200 animate-pulse h-6 w-16 rounded-full"></div>
      </div>
      
      {/* More message skeletons */}
      {[6, 7].map((i) => (
        <div key={i} className={`flex ${i % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
          <div className={`max-w-xs lg:max-w-md px-4 py-3 rounded-lg ${
            i % 2 === 0 ? 'bg-gray-100' : 'bg-gray-200'
          } animate-pulse`}>
            <div className="space-y-2">
              <div className="h-4 bg-gray-300 rounded w-5/6"></div>
            </div>
            <div className="h-3 bg-gray-300 rounded w-12 mt-2"></div>
          </div>
        </div>
      ))}
    </div>
  )
}

